const IGNORED = ['a', 'e', 'o', 'os', 'da', 'das', 'de', 'di', 'do', 'dos'];

export function capitalize(words, options = {}) {
  return words.map((word, index) => {
    if (index && IGNORED.includes(word)) {
      return word;
    }

    if (options.uppercase && options.uppercase.includes(word)) {
      return word.toUpperCase();
    }

    if (options.lowercase && options.lowercase.includes(word)) {
      return word.toLowerCase();
    }

    return word[0].toUpperCase() + word.slice(1);
  });
}

export default function namelize(value, options = {}) {
  if (typeof options !== 'object') {
    // eslint-disable-next-line no-param-reassign
    options = { limit: options };
  }

  if (!value || typeof value !== 'string') {
    return '';
  }

  let words = value.toLowerCase().replace(/ +/g, ' ').trim().split(' ');

  if (options.limit) {
    let index = options.limit;

    if (IGNORED.includes(words[index - 1])) {
      index += 1;
    }

    words = words.slice(0, index);
  }

  return capitalize(words, options).join(' ');
}
